import * as rudderanalytics from 'rudder-sdk-js';

import manifest from '#client/manifest';

import { ucAll, ucFunctional, ucMarketing } from './storageKeys';

const ucAcceptedAll = ucAll.get()?.toLowerCase() !== 'false';
const ucAcceptedAllFunctional = ucFunctional.get()?.toLowerCase() !== 'false';
const ucAcceptedAllMarketing = ucMarketing.get()?.toLowerCase() !== 'false';

const rudderStackDestination = {
  toTrack() {
    return ucAcceptedAll || ucAcceptedAllFunctional || ucAcceptedAllMarketing;
  },
  make() {
    if (rudderStackDestination.toTrack()) {
      rudderStackDestination.integrationOption = rudderStackDestination.getIntegrationOption();
      rudderanalytics.load(
        manifest.analytics.rudderstack.apiKey,
        manifest.analytics.rudderstack.url,
        {
          integrations: rudderStackDestination.integrationOption
        }
      );
      rudderanalytics.ready(() => {});
    }
  },
  getIntegrationOption() {
    if (ucAcceptedAll) {
      return { All: true };
    }

    const option = {
      All: false
    };

    if (ucAcceptedAllFunctional) {
      option.Mixpanel = true;
    }

    if (ucAcceptedAllMarketing) {
      option['Google Analytics 4'] = true;
    }

    return option;
  },

  logEvent(eventName, eventProperties) {
    // For any event transformation or PII filtering for different destination please refer to
    // https://counsl.atlassian.net/wiki/spaces/DATA/pages/3478356324/Rudderstack+GA4+Event+Transformation+and+Filtering
    rudderanalytics.track(eventName, eventProperties, {
      integrations: rudderStackDestination.integrationOption
    });
  },

  setUserProperties(userId, userProperties) {
    rudderanalytics.identify(
      userId,
      userProperties,
      {
        integrations: rudderStackDestination.integrationOption
      }
    );
  },

  identify(userId) {
    rudderanalytics.identify(userId, {}, {
      integrations: rudderStackDestination.integrationOption
    });
  },

  unidentify() {
    rudderanalytics.reset(false);
  },

  page(pageName, eventProperties) {
    rudderanalytics.page(pageName, eventProperties, {
      integrations: rudderStackDestination.integrationOption
    });
  }

};

export { rudderStackDestination };
